import * as React from "react";


import * as LF from "leaflet";
import 'leaflet/dist/leaflet.css'

import Highcharts from "highcharts";

import highchartsMap from "highcharts/modules/map";

import MapData from "../../ug/tzmap";
import HighchartsReact from "highcharts-react-official";
import map_image from "./../../resources/img/login_bg2.png";
import logo_image from "./../../resources/img/nlus.png"
import coat_image from "./../../resources/img/bibi_na_bwana.png"
import Checkbox from "../checkbox";
import GeneralSelect from "../general_select";
import Wait from "../wait";
import {SpatialService} from "../../service/v1/spatial";
import {LocalitiesService} from "../../service/v1/localities";
import {ProjectsService} from "../../service/v1/projects";

highchartsMap(Highcharts); // Initialize the map module

const pageBg = {
    minHeight: '100vh',
    width: '100%',
    background: `url(${map_image}) center center/cover no-repeat fixed`,
    position: 'relative',
    overflowY: 'auto',
    overflowX: 'hidden',
    maxHeight: '100vh',
};
const pageOverlay = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100vh',
    background: 'rgba(246,248,250,0.85)', // soft overlay for readability
    zIndex: 0,
    pointerEvents: 'none',
};
const fontFamily = 'Poppins, Inter, Open Sans, Helvetica, Arial, sans-serif';
const heroSection = {
    minHeight: 120,
    width: '100%',
    background: 'linear-gradient(120deg, #395d9a 0%, #2bbbad 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    color: 'white',
    fontFamily,
    marginBottom: 32,
    paddingTop: 60,
    boxShadow: '0 8px 32px 0 rgba(57,93,154,0.18), 0 1.5px 8px 0 rgba(43,187,173,0.10)'
};
const heroContent = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: '8px 0',
};
const heroLogo = {
    width: 140,
    minWidth: 80,
    height: 'auto',
    margin: '0 0',
    flexShrink: 0
};
const heroText = {
    flex: 1,
    textAlign: 'center',
    minWidth: 200,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
};
const heroTitle = {
    fontSize: 38,
    fontWeight: 800,
    letterSpacing: 1,
    marginBottom: 12,
    fontFamily,
    lineHeight: 1.1,
};
const heroTitleSmall = {
    ...heroTitle,
    fontSize: 24,
};
const heroSubtitle = {
    fontSize: 22,
    fontWeight: 400,
    marginBottom: 0,
    fontFamily
};
const sectionTitle = {
    fontSize: 24,
    fontWeight: 700,
    color: '#395d9a',
    margin: '48px 0 18px 0',
    textAlign: 'center',
    letterSpacing: 0.5,
    fontFamily
};
const divider = {
    width: 80,
    height: 4,
    background: 'linear-gradient(90deg, #2bbbad 0%, #395d9a 100%)',
    borderRadius: 2,
    margin: '0 auto 32px auto'
};
const cardRow = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 24,
    justifyContent: 'center',
    margin: '0 0 32px 0',
    width: '100%',
    boxSizing: 'border-box',
};
const statCard = accent => ({
    background: '#fff',
    borderRadius: 16,
    boxShadow: '0 2px 12px rgba(57,93,154,0.07)',
    padding: '28px 0 28px 18px',
    minWidth: 220,
    maxWidth: 340,
    margin: '12px',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 120,
    borderBottom: `5px solid ${accent}`,
    transition: 'box-shadow 0.2s, transform 0.2s',
    cursor: 'pointer',
    fontFamily,
    fontWeight: 500,
    position: 'relative',
    animation: 'fadeIn 1s',
    boxSizing: 'border-box',
});
const statIcon = accent => ({
    fontSize: 32,
    color: accent,
    marginBottom: 8
});
const statTitle = {
    fontWeight: 700,
    fontSize: 16,
    marginBottom: 4,
    color: '#395d9a',
    textAlign: 'center',
    fontFamily
};
const statCount = {
    fontSize: 32,
    fontWeight: 800,
    color: '#222',
    textAlign: 'center',
    marginBottom: 2,
    fontFamily
};
const statLabel = {
    fontSize: 13,
    color: '#888',
    marginTop: 2,
    fontFamily
};

export default class LandingPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            current_dashboard: <div>Loading...</div>,
            dashboard_data: {
                national: {
                    total: '0'
                },
                zonal: {
                    total: '0'
                },
                regional: {
                    total: '0'
                },
                district: {
                    total: '0'
                },
                village: {
                    total: '0'
                }
            },
            landUsesOptions: {
                endpoint: `landing-page/land-use`,
                value: 'id',
                label: 'name',
                placeholder: 'Select Land Use'
            },
            mapLandUsesOptions: {
                endpoint: `landing-page/map-land-use`,
                value: 'id',
                label: 'name',
                placeholder: 'Select Land Use'
            },
            modules: [],
            regionOptions: {},
            districtOptions: {},
            villageOptions: {},
            is_district_disabled: 'none',
            is_loaded: false,
        }
        this.generalSelect = this.generalSelect.bind(this)
        LandingPage.self = this
        LandingPage.loadData = LandingPage.loadData.bind(this)
        LandingPage.getSeries = LandingPage.getSeries.bind(this)
        this.loadProjectStats = this.loadProjectStats.bind(this)
    }

    componentDidMount() {
        // Get All locality levels and put to session
        LocalitiesService.fetchLocalityLevel().then(r => {
            try {
                let response = JSON.stringify(r.data.results)
                //console.log('HAPA : ' + response)
                JSON.parse(response).forEach(level => {
                    if (JSON.stringify(level.name).toString().toLowerCase().includes("nation")) {
                        sessionStorage.setItem('national_level_id', level.id)
                    }
                    if (JSON.stringify(level.name).toString().toLowerCase().includes("zone")) {
                        sessionStorage.setItem('zonal_level_id', level.id)
                    }
                    if (JSON.stringify(level.name).toString().toLowerCase().includes("region")) {
                        sessionStorage.setItem('regional_level_id', level.id)
                    }
                    if (JSON.stringify(level.name).toString().toLowerCase().includes("district")) {
                        sessionStorage.setItem('district_level_id', level.id)
                    }
                    if (JSON.stringify(level.name).toString().toLowerCase().includes("village")) {
                        sessionStorage.setItem('village_level_id', level.id)
                    }
                    if (JSON.stringify(level.name).toString().toLowerCase().includes("ward")) {
                        sessionStorage.setItem('ward_level_id', level.id)
                    }
                })
                //console.log('region : ' + sessionStorage.getItem('regional_level_id'))

            } catch (e) {
                console.log(e)
            }
        })
        LandingPage.loadData()
        this.loadProjectStats()
        const filterBtn = document.getElementById('filter-button');
        if (filterBtn) {
            filterBtn.disabled = true;
        }
    }

    loadProjectStats() {
        // Use the same approach as dashboard pane
        ProjectsService.fetchProjectStats().then(r => {
            try {
                console.log('Dashboard API Response:', r.data);
                console.log('Results:', r.data.results);
                console.log('Stats:', r.data.results?.stats);
                console.log('Projects:', r.data.results?.stats?.projects);
                
                // Get the total count from the same structure as dashboard pane
                const totalCount = r.data.results?.stats?.projects?.total || 0;
                
                console.log('Total count from API:', totalCount);
                
                // For now, let's use the total count for all levels since the API doesn't seem to provide separate counts
                // You may need to implement separate API calls for each administrative level
                this.setState({
                    dashboard_data: {
                        national: {
                            total: totalCount.toString()
                        },
                        zonal: {
                            total: totalCount.toString()
                        },
                        regional: {
                            total: totalCount.toString()
                        },
                        district: {
                            total: totalCount.toString()
                        },
                        village: {
                            total: totalCount.toString()
                        }
                    }
                });
            } catch (e) {
                console.log('Error parsing API response:', e);
                // Fallback to 0 if parsing fails
                this.setState({
                    dashboard_data: {
                        national: { total: '0' },
                        zonal: { total: '0' },
                        regional: { total: '0' },
                        district: { total: '0' },
                        village: { total: '0' }
                    }
                });
            }
        }).catch(e => {
            console.log('Error loading project stats:', e);
            // Fallback to 0 if API call fails
            this.setState({
                dashboard_data: {
                    national: { total: '0' },
                    zonal: { total: '0' },
                    regional: { total: '0' },
                    district: { total: '0' },
                    village: { total: '0' }
                }
            });
        });
    }

    static loadData(locality = null) {
        try {
            Wait.show('Loading...')
            SpatialService.fetchLandUsesPerLocality(locality).then(r => {
                Wait.dismiss()
                try {
                    let modules = []
                    r.data.results.forEach(d => modules.push(d))
                    if (locality !== null) {
                        console.log('FF Graph')
                    }
                    console.log(modules)
                    LandingPage.self.setState({
                        modules: [...modules],
                        nationalOptionBar: LandingPage.getSeries(modules),
                        regionOptions: {
                            endpoint: `localities/list?level_id=` + sessionStorage.getItem('regional_level_id'),
                            value: 'id',
                            label: 'name',
                            placeholder: 'Select Region'
                        },
                    })
                } catch (e) {
                    console.log(e)
                }

            })

        } catch (e) {
            console.log(e)
        }
    }

    generalSelect(data, name) {
        this.setState({
            [name]: data
        })
        console.log(this.state[name])
        console.log("dv : " + data.value)
        let ids = []

        if (name === 'land_uses') {
            switch (data.value) {
                case 'agriculture': {
                    this.setState({
                        is_settlement: 'none',
                        is_agriculture: 'table-row',
                    })
                }
                    break;
                case 'settlement': {
                    this.setState({
                        is_settlement: 'table-row',
                        is_agriculture: 'none',
                    })
                }
                    break;
            }
        }
        
        switch (name) {
            case 'region':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                }
                this.setState({
                    districtOptions: {
                        endpoint: `localities/list?level_id=` + sessionStorage.getItem('district_level_id') + '&parent_id=' + data.value,
                        value: 'id',
                        label: 'name',
                        placeholder: 'Select District'
                    },
                    is_village: false,
                    is_district: false,
                    is_region: true
                })
                document.getElementById('filter-button').style.backgroundColor = 'black'
                document.getElementById('filter-button').disabled = false
                break
            case 'district':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                }
                this.setState({
                    villageOptions: {
                        endpoint: `localities/list?level_id=` + sessionStorage.getItem('village_level_id') + '&parent_id=' + data.value,
                        value: 'id',
                        label: 'name',
                        placeholder: 'Select Village'
                    },
                    is_village: false,
                    is_region:false,
                    is_district: true
                })
                break
            case 'village': {
                this.setState({
                    is_district: false,
                    is_region:false,
                    is_village: true
                })
            }
        }
        console.log("dv : " + data.value)

    }

    render() {
        const { dashboard_data } = this.state;
        const username = sessionStorage.getItem('username') || 'Guest';
        const isSmallScreen = typeof window !== 'undefined' && window.innerWidth < 600;
        return (
            <div style={{...pageBg, position: 'relative'}}>
                <div style={pageOverlay}></div>
                <div style={{position: 'relative', zIndex: 1}}>
                {/* Hero Section with two logos */}
                <div style={heroSection}>
                    <div style={heroContent}>
                        <img src={coat_image} alt="Coat of Arms" style={{...heroLogo}} />
                        <div style={{minWidth: 24}}></div>
                        <div style={heroText}>
                            <div style={isSmallScreen ? heroTitleSmall : heroTitle}>National Land Use Information System</div>
                            <div style={heroSubtitle}>Empowering Tanzania with Land Use Data & Planning Tools</div>
                        </div>
                        <div style={{minWidth: 24}}></div>
                        <img src={logo_image} alt="NLUIS Logo" style={{...heroLogo, width: 200, minWidth: 120}} />
                    </div>
                </div>

                {/* System Overview */}
                <div style={sectionTitle}>Welcome to NLUIS</div>
                <div style={divider}></div>
                <div style={{background: 'rgba(255,255,255,0.95)', borderRadius: 14, fontSize: 18, color: '#395d9a', fontWeight: 500, padding: 24, maxWidth: 900, margin: '0 auto 32px auto', boxShadow: '0 1px 8px rgba(57,93,154,0.07)', fontFamily: 'Poppins, Inter, Open Sans, Helvetica, Arial, sans-serif'}}>The National Land Use Information System (NLUIS) is a comprehensive platform for managing, visualizing, and reporting on land use plans across Tanzania. It empowers planners, researchers, and the public with up-to-date data, interactive maps, and powerful tools for decision-making.</div>

                {/* Key Features */}
                <div style={sectionTitle}>Key Features</div>
                <div style={divider}></div>
                <div style={cardRow}>
                    <div style={statCard('#395d9a')}><span className="fa fa-map" style={statIcon('#395d9a')}/> <br/>Interactive Land Use Maps</div>
                    <div style={statCard('#2bbbad')}><span className="fa fa-bar-chart" style={statIcon('#2bbbad')}/> <br/>Real-time Statistics & Dashboards</div>
                    <div style={statCard('#fbc02d')}><span className="fa fa-search" style={statIcon('#fbc02d')}/> <br/>Advanced Search & Filtering</div>
                    <div style={statCard('#f44336')}><span className="fa fa-download" style={statIcon('#f44336')}/> <br/>Data Download & Export</div>
                    <div style={statCard('#8bc34a')}><span className="fa fa-info-circle" style={statIcon('#8bc34a')}/> <br/>User Guidance & Support</div>
                </div>

                {/* Contact and Support */}
                <div style={sectionTitle}>Contact & Support</div>
                <div style={divider}></div>
                <div style={{display: 'flex', flexWrap: 'wrap', gap: 24, justifyContent: 'center', margin: '0 0 32px 0', boxSizing: 'border-box'}}>
                    <div style={{background: '#fff', borderRadius: 12, boxShadow: '0 1px 8px rgba(57,93,154,0.07)', padding: '22px 18px', minWidth: 220, maxWidth: 340, margin: '12px', flex: 1, textAlign: 'center', fontSize: 16, fontFamily, boxSizing: 'border-box'}}>
                        <span className="fa fa-envelope" style={{fontSize: 22}}/> Email: <a href="mailto:support@nluis.go.tz">support@nluis.go.tz</a>
                    </div>
                    <div style={{background: '#fff', borderRadius: 12, boxShadow: '0 1px 8px rgba(57,93,154,0.07)', padding: '22px 18px', minWidth: 220, maxWidth: 340, margin: '12px', flex: 1, textAlign: 'center', fontSize: 16, fontFamily, boxSizing: 'border-box'}}>
                        <span className="fa fa-phone" style={{fontSize: 22}}/> Phone: +255 769 971773
                    </div>
                    <div style={{background: '#fff', borderRadius: 12, boxShadow: '0 1px 8px rgba(57,93,154,0.07)', padding: '22px 18px', minWidth: 220, maxWidth: 340, margin: '12px', flex: 1, textAlign: 'center', fontSize: 16, fontFamily, boxSizing: 'border-box'}}>
                        <span className="fa fa-question-circle" style={{fontSize: 22}}/> <a href="#">Help Center</a>
                    </div>
                </div>
                </div>
            </div>
        );
    }


    static getSeries(modules) {
        let series = []
        modules.map((d, i) => {
            let entry = {name: d.use, data: [Number(d.area)]}
            series.push(entry)
        })
        console.log(series)
        return {
            chart: {
                type: 'column'
            },

            title: {
                text: 'Land Use Plan per Hectare'
            },

            subtitle: {
                text: ''
            },

            yAxis: {
                title: {
                    text: 'Hectares'
                }
            },

            xAxis: {
                categories: ['Land Use'],
                crosshair: true
            },

            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'middle'
            },

            /* plotOptions: {
                 series: {
                     label: {
                         connectorAllowed: false
                     },
                     /!*pointStart: 2013*!/
                 }
             },
 */
            series: series,
            /* series: ,*/

            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            layout: 'horizontal',
                            align: 'center',
                            verticalAlign: 'bottom'
                        }
                    }
                }]
            }
        }
    }

    changeGraph() {
        console.log('Change Graph')
        let locality
        if (LandingPage.self.state.is_village) {
            locality = LandingPage.self.state.village.value
        } else if (LandingPage.self.state.is_district){
            locality = LandingPage.self.state.district.value
        } else {
            locality = LandingPage.self.state.region.value
        }
        console.log(locality)
        LandingPage.loadData(locality)
    }
}

